export enum ComplaintStatus {
    ChuaXuLy = 1,
    DaXuLy= 2
}
